/* eslint-disable react/destructuring-assignment */ import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { HeaderContainer, NavigationContainer, SegmentContainer, SegmentForegroundContainer } from "./Segment.styles";
import { SegmentImageBackground } from "./SegmentImageBackground";
var isBasicSegment = function(props) {
    return !Object.prototype.hasOwnProperty.call(props, "image");
};
var selectContainer = function(segmentType) {
    switch(segmentType){
        case "header":
            return HeaderContainer;
        case "nav":
            return NavigationContainer;
        case "segment":
        default:
            return SegmentContainer;
    }
};
var DEFAULT_OPTIONS = {
    hasPadding: false,
    segmentType: "segment",
    spacingScale: 1
};
var processOptions = function(props) {
    if (isBasicSegment(props)) {
        return _object_spread_props(_object_spread({}, props), {
            hasPadding: Boolean(props.hasPadding),
            segmentType: props.segmentType || DEFAULT_OPTIONS.segmentType,
            spacingScale: props.spacingScale || DEFAULT_OPTIONS.spacingScale
        });
    }
    return DEFAULT_OPTIONS;
};
var Segment = function(props) {
    var ref = processOptions(props), fillColor = ref.fillColor, hasPadding = ref.hasPadding, segmentType = ref.segmentType, spacingScale = ref.spacingScale;
    var Container = selectContainer(segmentType);
    return /*#__PURE__*/ _jsxs(Container, {
        fillColor: fillColor,
        hasPadding: hasPadding,
        id: props.id,
        spacingScale: spacingScale,
        needLayoutContentPadding: isBasicSegment(props) || !props.isStage || props.includeSearch,
        children: [
            /*#__PURE__*/ _jsx(SegmentImageBackground, _object_spread({}, props)),
            /*#__PURE__*/ _jsx(SegmentForegroundContainer, {
                children: props.children
            })
        ]
    });
};
export { Segment };
